(function(window, youtubeIdParserDefinition) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.youtubeIdParser = youtubeIdParserDefinition();
})(this, function() {
   'use strict';

   var getIdFromUrl = function(videoUrl) {
      var videoIdRegex = /(youtu\.be\/|v=)(.{11})/i;
      var videoIdMatch = videoIdRegex.exec(videoUrl);
      return videoIdMatch && videoIdMatch[2] ? videoIdMatch[2] : '*';
   };

   return {
      getIdFromUrl: getIdFromUrl
   };
});
